import React, {Component} from 'react';
import {Menu, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';
import {ContentDispatch} from 'framework';
import {checkIfIncludedsIn, compileContent} from 'common/utils';
import {APP_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

const SHOW_HIDE = 'ShowHide';
const TOGGLE = 'Toggle';

/* can be used nested inside another sidenav */
export class SideNavInternal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: '',
      detailTitles: props.items,
    };
  }

  UNSAFE_componentWillMount() {
    let title = '';
    if (this.props.contents) {
      title = this.getLocationTitle();
    }

    this.setState({
      activeSection: title,
    });
  }

  componentDidUpdate(prevProps) {
    const {location, items} = this.props;
    if (!_.isEqual(location, prevProps.location) || !_.isEqual(items, prevProps.items)) {
      const title = this.getLocationTitle();
      document.title = APP_PAGE + ' ' + title;
      this.setState({
        activeSection: title,
        detailTitles: items,
      });
    }
  }

  getLocationTitle() {
    const {contents} = this.props;
    let {location} = this.props;
    let configHelper = {
      contents,
    };
    let title = '';
    
    if (location !== '') {
      // The following locationString will match contents['#navLinkId'] and contents['#parentNavLinkId']['#childNavLinkId']
      const locationString = location ? location.match(/^contents\['#(\w+)'\](\['#(\w+)'\])?$/) : null;
      if (locationString) {
        const selectedIndex = _.findIndex(configHelper.contents, { navLinkId: locationString[1] });
        location = `contents[${selectedIndex}]`;

        const hasChild = locationString[3];
        if(hasChild) {
          const selectedIndexChild = _.findIndex(configHelper.contents[selectedIndex]?.contents, { navLinkId: locationString[3] });
          location += selectedIndexChild > -1 ? `contents[${selectedIndexChild}]` : '';
        }
      }

      const componentConfig = location ? _.get(configHelper, location) : configHelper;
      const contents = _.get(componentConfig, 'contents');

      title = _.map(contents, (menuItem) => {
        return menuItem.title;
      });

      title = (componentConfig && componentConfig.title) || title.toString();
    }
    return title;
  }

  handleClick = (title, location) => {
    this.setState({activeSection: title});
    this.props.navToSpecificLocation(location);
  };

  generateMenuItem = (title, spot, level, classes) => {
    if (title) {
      return (
        <div key={title}>
          <Menu.Item
            name={title}
            onClick={() => {
              this.handleClick(title, spot);
            }}
            key={title}
            as="a"
            active={title === this.state.activeSection}
            href={'#' + title}
            className={classes}
            title={title}
          >
            {title}
          </Menu.Item>
        </div>
      );
    }
  };

  generateExternalLink = (title, classes, path) => {
    let compiled = _.template(path);
    // Strip off everything but root URL (may be a better way to do this?):
    let newLocation = window.location.href.replace(this.props.routerLocation.search, '');
    newLocation = newLocation.replace(this.props.routerLocation.hash, '');
    newLocation = newLocation.replace(
      this.props.routerLocation.pathname,
      compiled(this.props)
    );
    return (
      <Menu.Item
        name={title}
        key={title}
        as="a"
        active={false}
        href={newLocation}
        target="_blank"
        className={classes}
        title={title}
      >
        <Icon name="external alternate" />
        {title}
      </Menu.Item>
    );
  };

  shouldDisplayNav = (menuItem) => {
    let data = undefined;
    if (menuItem.dataPath) {
      // Get data
      let dependency = _.find(
        this.props.navDependencies,
        (dep) => dep.path === menuItem.dataPath
      );
      data = this.props[dependency.name];
    }
    return shouldDisplay(data, menuItem.toMatch, menuItem.shouldDisplayRules, {
      ...this.props,
      shouldDisplayIfAnyRules: menuItem.shouldDisplayIfAnyRules,
    });
  };

  generateMenu = (menuItem, spot, level) => {
    let currLevel = level;
    let nextLevel = currLevel + 1;
    let currLevelMenuItem = null;
    let subLevelMenuItems = null;
    let menuTitle = null;

    // generate current menu item
    if (menuItem.showTitle !== false) {
      let classes = `${menuItem.title} item textSmall indent_${currLevel}${
        menuItem.samePageNav ? ' leftBar' : ' leftBarIndented'
      }`;

      if (menuItem.type === SHOW_HIDE && !this.shouldDisplayNav(menuItem)) {
        currLevelMenuItem = null;
      } else if (menuItem.linkTo) {
        currLevelMenuItem = this.generateExternalLink(
          menuItem.title,
          classes,
          menuItem.linkTo
        );
      } else {
        currLevelMenuItem = this.generateMenuItem(
          menuItem.title,
          spot,
          nextLevel,
          classes
        );
      }

      const toggles = _.get(this.props, 'toggles');
      const fundingOpportunityId = _.get(this.props, 'fundingOpportunityId');
      const categoryId = _.get(this.props, 'categoryId');
      const type = _.get(menuItem, 'type');
      const toggle = _.get(menuItem, 'toggle');
      const entityType = _.get(menuItem, 'entityType');
      let id;

      if (entityType === 'fundingOpportunity') {
        id = fundingOpportunityId;
      } else {
        id = categoryId;
      }

      const ifNot = _.get(menuItem, 'ifNot');     
      if (type === TOGGLE  && !ifNot) {
        const contents = _.get(menuItem, 'contents');
        _.map(contents, (menuItem) => {
          currLevelMenuItem = this.generateMenuItem(
            menuItem.title,
            spot,
            nextLevel,
            classes
          );
        });
      }

      if (menuItem.navTitle) {
        menuTitle = (
          <h4 className="dynamicSideNav-header">
            {compileContent(menuItem.navTitle, this.props)}
          </h4>
        );
      }
    }

    // generate sub-menu items
    if (menuItem.navContents) {
      // generate sub-menu using specified dynamic component widgets
      subLevelMenuItems = _.map(menuItem.navContents, (config) => (
        <ContentDispatch config={config} currentIndent={currLevel} spot={spot} />
      ));
    } else if (
      menuItem.navToChildren &&
      (menuItem.type != SHOW_HIDE || this.shouldDisplayNav(menuItem))
    ) {
      //menuItem.type === 'ShowHide', then instead of mapping through menuItem.contents, map through menuItem.renderAs.contents
      let subMenuItemsList;
      if (menuItem.type === 'ShowHide') {
        subMenuItemsList = menuItem.renderAs.contents;
      } else {
        subMenuItemsList = menuItem.contents;
      }
      subLevelMenuItems = _.map(subMenuItemsList, (submenu, index) => {
        let subSpot = spot + `.contents[${index}]`;
        if (
          !(
            submenu.dataBasedNav &&
            !checkIfIncludedsIn(this.state.detailTitles, submenu.title)
          )
        ) {
          // recursively generate sub-menu
          return this.generateMenu(submenu, subSpot, nextLevel);
        } else {
          // legacy way of generating menu items based on data, deprecated
          return <div key={`${submenu.title}${index}`} />;
        }
      });
    }

    return (
      <div key={menuItem.title}>
        {menuTitle}
        {currLevelMenuItem}
        {subLevelMenuItems}
      </div>
    );
  };

  renderInternal() {
    let {contents, startingIndentLevel} = this.props;

    return _.map(contents, (menuItem, index) => {
      let spot = `contents[${index}]`;
      return this.generateMenu(menuItem, spot, startingIndentLevel || 0);
    });
  }

  render() {
    let {title} = this.props;

    return (
      <React.Fragment>
        {this.props.showTitle !== false && (
          <Menu.Item
            name={title}
            id={title}
            onClick={() => this.handleClick('', '')}
            key={title}
            active={'' === this.state.activeSection}
            as="a"
            className={title + ' item textSmall'}
          >
            {this.props.title}
          </Menu.Item>
        )}
        {this.props.navToChildren && this.renderInternal()}
      </React.Fragment>
    );
  }
}

SideNavInternal.propTypes = {
  navToSpecificLocation: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  contents: PropTypes.array.isRequired,
  showTitle: PropTypes.bool,
  location: PropTypes.string.isRequired,
};

export const mapStateToProps = (state, componentProps) => {
  let props = {
    routerLocation: _.get(state, 'router.location'),
    toggles: _.get(state, 'toggles.toggles'),
    fundingOpportunityId: _.get(state, 'dynamicComponent.data.fundingOpportunityId'),
    categoryId: _.get(state, 'dynamicComponent.data.categoryId'),
  };

  const navDependencies = _.get(
    componentProps,
    'navDependencies',
    _.get(state, 'dynamicComponent.config.payload.navDependencies')
  );
  if (navDependencies) {
    _.forEach(navDependencies, (dep) => {
      props[dep.name] = _.get(state.dynamicComponent, dep.path);
    });
  }
  return props;
};

export default connect(mapStateToProps)(SideNavInternal);
